import { render, staticRenderFns } from "./form-activities.vue?vue&type=template&id=fd89b040&scoped=true"
import script from "./form-activities.vue?vue&type=script&lang=js"
export * from "./form-activities.vue?vue&type=script&lang=js"
import style0 from "./form-activities.vue?vue&type=style&index=0&id=fd89b040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd89b040",
  null
  
)

export default component.exports